import React from 'react';
import PropTypes from 'prop-types';
import FormattedAddress from '../../sections/shop/FormattedAddress';
import Form from '../forms/Form';
import FormAddress from '../forms/Address/FormAddress';
import Anchor from '../Anchor';
import CountryProp from '../forms/Address/CountryProp';
import UserProp from '../propTypes/userProp';
import AddressProp from '../propTypes/addressProp';
import translate from '../translate';

const YourBilling = props => {
  const {
    t,
    billingAddress,
    handleAddressForm,
    orderAlreadyCreated,
    showAddressForm,
    saveAddress,
    countries,
    user,
    handleAddressChange,
    errors,
  } = props;
  const validationRules = {
    firstName: { required: true },
    lastName: { required: true },
    address_1: { required: true },
    city: { required: true },
    zipCode: { required: true },
    countryCode: { required: true },
    phone: { maxlength: 20 },
  };
  const hasError = errors?.billingAddress;
  return (
    <div>
      <h3>{t('shop.cart.billing')}</h3>
      <div className={`row ${showAddressForm ? 'display-address' : ''}`}>
        {billingAddress && billingAddress.address_1 && !showAddressForm ? (
          <div className="col-lg-8 col-12">
            <FormattedAddress
              address={billingAddress}
              showOptionalFields
              nameContainer="nameFormatted-checkout"
              addressContainer="addressFormatted-checkout"
              containerClass="col-10 fix-width-address"
              formatName
            />
          </div>
        ) : (
          <span className={`${hasError ? 'hint-no-address-error' : ''} hint-no-address col-lg-8 col-12`}>
            {t('checkout.address.hint')}
          </span>
        )}
        <div className="col-lg-4 col-12">
          <div className="change-address">
            <button
              type="button"
              className="btn btn-metal m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill secondary-btn"
              onClick={() => handleAddressForm(true)}
              disabled={orderAlreadyCreated}
            >
              <i className="fa fa-pen" />
            </button>
          </div>
        </div>
      </div>
      {showAddressForm && (
        <div className="add-new-address">
          <Form
            id="yourBillingAddress"
            submitMethod={saveAddress}
            validationRules={validationRules}
          >
            {submitHandler => (
              <>
                <FormAddress
                  countries={countries}
                  address={billingAddress}
                  onFieldChange={handleAddressChange}
                  isShopCheckout
                  countryToFilter={(billingAddress && billingAddress.countryCode) || null}
                  user={user}
                />
                <br />
                <div className="handle-form-address">
                  <Anchor
                    className="btn m-btn--pill btn-dynamic btn-save-address"
                    onClick={submitHandler}
                  >
                    {t('save')}
                  </Anchor>
                  <Anchor
                    className="btn m-btn--pill btn-danger btn-cancel-address"
                    onClick={() => handleAddressForm(false)}
                  >
                    {t('cancel')}
                  </Anchor>
                </div>
              </>
            )}
          </Form>
        </div>
      )}
    </div>
  );
};

YourBilling.propTypes = {
  t: PropTypes.func.isRequired,
  countries: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
  saveAddress: PropTypes.func.isRequired,
  showAddressForm: PropTypes.bool.isRequired,
  handleAddressForm: PropTypes.func.isRequired,
  user: PropTypes.shape(UserProp.propType).isRequired,
  handleAddressChange: PropTypes.func.isRequired,
  billingAddress: PropTypes.shape(AddressProp.propType),
  orderAlreadyCreated: PropTypes.string,
  errors: PropTypes.shape({
  }),
};

YourBilling.defaultProps = {
  billingAddress: {},
  orderAlreadyCreated: null,
  errors: {},
};

export default translate(YourBilling);
